import {setupAccordions} from '$c3base/accordion.js';

const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
        //console.log(entry);
        if (entry.isIntersecting) {
            entry.target.classList.add('show');
        } else {
            //entry.target.classList.remove('show');
        }
    })
})

$(function () {
    setupAccordions('.accordion');

    const hiddenElements = document.querySelectorAll('.hidden');
    hiddenElements.forEach((el) => observer.observe(el));

    let requestButton = document.querySelectorAll('.request-submit');
    requestButton.forEach((element) => {
        element.addEventListener('click', function (e) {
            e.preventDefault();
            let anreise = element.parentElement.parentElement.querySelectorAll('#anreise');
            let abreise = element.parentElement.parentElement.querySelectorAll('#abreise');
            let adults = element.parentElement.parentElement.querySelectorAll('#adults');
            let rooms = element.parentElement.parentElement.querySelectorAll('#rooms');

            localStorage.setItem('anreise', anreise[0].value);
            localStorage.setItem('abreise', abreise[0].value);
            localStorage.setItem('erwachsene', adults[0].value);
            localStorage.setItem('zimmer', rooms[0].value);

            location.href = element.getAttribute('href');
        })
    })

    const requestForm = document.querySelectorAll('.powermail_form_1')[0];
    if (requestForm != null && requestForm.length) {
        requestForm.querySelectorAll('#powermail_field_datumderanreise')[0].value = localStorage.getItem('anreise');
        requestForm.querySelectorAll('#powermail_field_datumderabreise')[0].value = localStorage.getItem('abreise');
        requestForm.querySelectorAll('#powermail_field_anzahlzimmer')[0].value = localStorage.getItem('zimmer');
        requestForm.querySelectorAll('#powermail_field_anzahlerwachsene')[0].value = localStorage.getItem('erwachsene');

        localStorage.removeItem('anreise');
        localStorage.removeItem('abreise');
        localStorage.removeItem('erwachsene');
        localStorage.removeItem('zimmer');
    }

    const hamburgerMenu = document.querySelectorAll('.hamburger')[0];
    const bodyElement = document.querySelectorAll('body')[0];
    hamburgerMenu.addEventListener('click', function (e) {
        if (bodyElement.classList.contains('menuOpen')) {
            bodyElement.classList.remove('menuOpen');
        } else {
            bodyElement.classList.add('menuOpen');
        }
    })

});

$(window).on('load', function (e) {

});

$(window).on('resize', function (e) {

});
